import { createFantasy11Routes } from "@template/utils";

const  FantasyCasinoWrapper  = () =>  import("./views/FantasyCasinoWrapper.vue");

export default createFantasy11Routes(FantasyCasinoWrapper);